import { useMemo } from 'react'

import { isPolicyholderWithAccount } from '../../../../domain'
import {
  AnonymousCondition,
  DisclosureSectionCondition,
} from '../../../../state/configuration'
import { usePolicyholder } from '../../../authentication'

export const isAnonymousCondition = (
  condition: unknown,
): condition is AnonymousCondition =>
  Object.prototype.hasOwnProperty.call(condition, 'isAnonymousOnly')

export const useAnonymousCondition = () => {
  const { policyholder } = usePolicyholder()
  return useMemo(
    () => (condition: AnonymousCondition) =>
      isPolicyholderWithAccount(policyholder) !== condition.isAnonymousOnly,
    [policyholder],
  )
}

export const useSectionConditions = () => {
  const anonymousCondition = useAnonymousCondition()

  return useMemo(
    () => (it: DisclosureSectionCondition) => {
      return isAnonymousCondition(it) ? anonymousCondition(it) : false
    },
    [anonymousCondition],
  )
}
